import { Component } from '@angular/core';
import { DevelopChallengeComponent } from '../develop-challenge.component';

@Component({
  selector: 'app-develop-challenge-top-ideas',
  templateUrl: './develop-challenge-top-ideas.component.html',
  styleUrls: ['./develop-challenge-top-ideas.component.scss']
})
export class DevelopChallengeTopIdeasComponent {

  constructor(public developChallengeComponent: DevelopChallengeComponent) { }

}
